import { ALL_COUNTRIES_URL } from 'constants/ApiConstants';
import type { Action, GetRequest } from 'modules/global/generic.types';

import { FETCH_COUNTRIES } from './actionTypes';

export const fetchCountries = (): Action<GetRequest<undefined>> => ({
  type: FETCH_COUNTRIES,
  payload: {
    request: {
      method: 'GET',
      url: ALL_COUNTRIES_URL
    },
  },
  meta: {
    '@app-request': true,
  }
});
